import script from "./LanguageList.vue?vue&type=script&setup=true&lang=ts"
export * from "./LanguageList.vue?vue&type=script&setup=true&lang=ts"

import "./LanguageList.vue?vue&type=style&index=0&id=30beed58&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30beed58"]])

export default __exports__